import { jsx, jsxs } from 'react/jsx-runtime';
import '../../../../contexts/MenuContext/index.mjs';
import { AvailableLanguages } from '../../../../contexts/MenuContext/mapping.mjs';
import { CustomButton, LanguageKey, LanguageValue } from '../LanguageFrame.styles.mjs';
import '../translations/index.mjs';
import { buildLanguageLink } from '../utils/buildLanguageLink.mjs';
import { Wrap } from './Mobile.styles.mjs';
import { useMenu } from '../../../../contexts/MenuContext/context.mjs';
import EN_TRANSLATION from '../translations/en.json.mjs';
"use strict";
const LanguageFrameMobile = ({
  onLanguageChange,
  onClose
}) => {
  const {
    deployedLanguages,
    language,
    storeId,
    setActiveModal
  } = useMenu();
  return /* @__PURE__ */jsx(Wrap, {
    children: Object.entries(AvailableLanguages).map(([key, val]) => {
      if (deployedLanguages.includes(key)) {
        const href = buildLanguageLink(storeId, key);
        if (!href) return null;
        return /* @__PURE__ */jsxs(CustomButton, {
          anchor: true,
          $active: key === language,
          variant: "gray",
          href,
          onClick: e => {
            onLanguageChange?.(e, href, key);
            setActiveModal(null);
            onClose?.();
          },
          children: [/* @__PURE__ */jsx(LanguageKey, {
            children: key
          }), "\xA0", /* @__PURE__ */jsx(LanguageValue, {
            children: EN_TRANSLATION[val]
          })]
        }, val);
      } else {
        return null;
      }
    })
  });
};
export { LanguageFrameMobile };
//# sourceMappingURL=Mobile.mjs.map
